// /src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import { login, logout, verifyAuth,loginWithOtp} from "../api/auth/authService";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // ✅ 1. Handle background events (No redirects here!)
  useEffect(() => {
    const handleAuthExpired = () => setIsAuthenticated(false);
    const handleStorageLogout = (event) => {
      if (event.key === "logout") setIsAuthenticated(false);
    };

    window.addEventListener("auth-expired", handleAuthExpired);
    window.addEventListener("storage", handleStorageLogout);
    return () => {
      window.removeEventListener("auth-expired", handleAuthExpired);
      window.removeEventListener("storage", handleStorageLogout);
    };
  }, []);

  // ✅ 2. Silent Initial Verification
  useEffect(() => {
    const verifyUser = async () => {
      try {
        await verifyAuth(); 
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false); // Always stop loading so public routes can show
      }
    };
    verifyUser();
  }, []);

  const handleLoginWithOtp = async (userName, otp) => {
  try {
    await loginWithOtp(userName, otp);
    setIsAuthenticated(true);
    return true;
  } catch (error) {
    setIsAuthenticated(false);
    throw error;
  }
};
  const handleLogin = async (formData, navigate) => {
    try {
      await login(formData);
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      setIsAuthenticated(false);
      throw error;
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      setIsAuthenticated(false);
      localStorage.setItem("logout", Date.now());
      window.location.href = "/login"; // Logout is the ONLY place for hard redirect
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login: handleLogin, logout: handleLogout,loginWithOtp: handleLoginWithOtp, }}>
      {children}
    </AuthContext.Provider>
  );
};